// Photo types based on CMS API PhotoResponse and related schemas

export enum PhotoParentType {
  Service = 'Service',
  ServiceOption = 'ServiceOption',
  Vendor = 'Vendor',
  Organization = 'Organization',
  /** Optional wide logo for the employee-app home header (transparent PNG recommended). */
  OrganizationWideLogo = 'OrganizationWideLogo',
  User = 'User',
  Activity = 'Activity',
  Perk = 'Perk'
}

export interface PhotoResponse {
  id: string; // UUID format
  parentType: PhotoParentType;
  parentId: string; // UUID format
  url?: string;
  isPrimary: boolean;
  sortOrder: number;
  altText?: string;
}

export interface PhotoUploadInfo {
  photoId: string; // UUID format
  uploadUrl?: string;
  expiresAt: string; // ISO date-time
  blobName?: string;
  maxFileSizeBytes: number;
  allowedContentTypes?: string[];
}

export interface PhotoUploadUrlsResponse {
  parentType: PhotoParentType;
  parentId: string; // UUID format
  uploadInfos?: PhotoUploadInfo[];
}

export interface RequestPhotoUploadUrlsRequest {
  parentType: PhotoParentType;
  parentId: string; // UUID format
  photoCount: number; // 1-20
  startingSortOrder?: number; // 0-2147483647, default 0
  markFirstAsPrimary?: boolean; // default false
  maxFileSizeBytes?: number; // 1-52428800 (50MB), default 10485760 (10MB)
  allowedContentTypes?: string[]; // default ["image/jpeg", "image/png", "image/webp"]
}

// Helper type for file upload with metadata
export interface PhotoFile {
  file: File;
  uploadInfo: PhotoUploadInfo;
  progress?: number;
  status?: 'pending' | 'uploading' | 'uploaded' | 'confirmed' | 'error';
  error?: string;
}
